import { render } from "./ModalNuovaRichiesta.vue?vue&type=template&id=00f8c024&scoped=true"
import script from "./ModalNuovaRichiesta.vue?vue&type=script&lang=js"
export * from "./ModalNuovaRichiesta.vue?vue&type=script&lang=js"

import "./ModalNuovaRichiesta.vue?vue&type=style&index=0&id=00f8c024&scoped=true&lang=css"

import exportComponent from "/var/www/app_server_flask/temp/temp_app_ingegno_energy-saving_1764367324033741919/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00f8c024"]])

export default __exports__